export default __webpack_public_path__ + "static/media/tilted-home-main-image.8a28290d.png";